export enum ButtonState {
	default = 'default',
	busy = 'busy',
	completed = 'completed',
	errored = 'errored',
}
